module.exports = __webpack_public_path__ + "img/empty-sort-icons.b8db64ed.svg";